const BASE_URL = 'https://www.airplaten.com'
const DEFAULT_TITLE = 'Airplaten | Carbon Fiber Knife Sharpening Platen for Belt Grinders'
const DEFAULT_DESC = 'Airplaten builds carbon fiber platens for belt grinders. Engineered for knife sharpening, blade grinding, and metalworking. Fits 2x42, 2x36, and Bucktool grinders. Lifetime warranty.'
const DEFAULT_IMAGE = `${BASE_URL}/images/og-image.jpg`

/**
 * Update page title, meta description, canonical, and OG/Twitter tags.
 * Call from every page renderer.
 */
export function updateMeta({ title, description, canonicalPath = '/', image } = {}) {
  const fullTitle = title || DEFAULT_TITLE
  const desc = description || DEFAULT_DESC
  const url = `${BASE_URL}${canonicalPath}`
  const img = image || DEFAULT_IMAGE

  document.title = fullTitle

  setMeta('description', desc)
  setMeta('og:title', fullTitle, true)
  setMeta('og:description', desc, true)
  setMeta('og:url', url, true)
  setMeta('og:image', img, true)
  setMeta('twitter:title', fullTitle)
  setMeta('twitter:description', desc)
  setMeta('twitter:image', img)

  // Canonical
  let link = document.querySelector('link[rel="canonical"]')
  if (!link) {
    link = document.createElement('link')
    link.rel = 'canonical'
    document.head.appendChild(link)
  }
  link.href = url
}

/**
 * Inject or replace a JSON-LD script block in <head>.
 * Pass a unique id to allow multiple blocks (e.g. 'product', 'breadcrumb').
 */
export function injectJsonLd(data, id = 'page-jsonld') {
  const scriptId = `jsonld-${id}`
  let el = document.getElementById(scriptId)
  if (!el) {
    el = document.createElement('script')
    el.type = 'application/ld+json'
    el.id = scriptId
    document.head.appendChild(el)
  }
  el.textContent = JSON.stringify(data)
}

/**
 * Remove a JSON-LD block by id.
 */
export function removeJsonLd(id = 'page-jsonld') {
  document.getElementById(`jsonld-${id}`)?.remove()
}

/**
 * Remove all dynamic JSON-LD blocks (called on route change).
 */
export function clearJsonLd() {
  document.querySelectorAll('script[id^="jsonld-"]').forEach(el => el.remove())
}

function setMeta(nameOrProp, content, isProperty = false) {
  const attr = isProperty ? 'property' : 'name'
  let el = document.querySelector(`meta[${attr}="${nameOrProp}"]`)
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute(attr, nameOrProp)
    document.head.appendChild(el)
  }
  el.setAttribute('content', content)
}
